import { render } from "./CurrentVersionScreen.vue?vue&type=template&id=60a04a76&scoped=true"
import script from "./CurrentVersionScreen.vue?vue&type=script&lang=js"
export * from "./CurrentVersionScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=60a04a76&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a04a76"]])

export default __exports__